import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'user-active-return-act',
  templateUrl: './user-active-return-act.component.html',
  styleUrls: ['./user-active-return-act.component.scss']
})
export class UserActiveReturnActComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
